module.exports = { "default": require("core-js/library/fn/math/fround"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/fround.js
// module id = 775
// module chunks = 0